import { getLaboratoryNetworks, getStates, getQuotationPcrExam, getLaboratoriesByState } from '../api/services'
import { initialState, initialStateByModule } from './state'

const SET_PASSENGERS = 'setPassengers'
const SET_LABORATORIES = 'setLaboratories'
const SET_STATES = 'setStates'
const SET_CURRENT_VALUE = 'setCurrentValue'
const SET_TOTAL_VALUE = 'setTotalValue'
const RESET = 'resetAdditional'
const RESET_PASSENGERS = 'resetPassengers'
const SET_LOADING = 'setLoading'
const SET_LABORATORIES_BY_STATE = 'setLaboratoriesByState'
const SET_STATE_SELECTED = 'setStateSelected'
const SET_ACTIVE = 'setActive'

const state = initialStateByModule('additional')

const getters = {}

const mutations = {
  [RESET] (state) {
    const s = initialState.additional
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  [SET_PASSENGERS] (state, payload) {
    state.pcr.listSelectedPassengers = payload
  },
  [SET_LABORATORIES] (state, payload) {
    state.pcr.laboratories = payload
  },
  [SET_STATES] (state, payload) {
    state.pcr.states = payload
  },
  [SET_CURRENT_VALUE] (state, payload) {
    state.pcr.currentValue = payload
  },
  [SET_TOTAL_VALUE] (state, payload) {
    state.pcr.totalValue = payload
  },
  [RESET_PASSENGERS] (state, payload) {
    state.pcr.listSelectedPassengers = []
  },
  [SET_LOADING] (state, payload) {
    state.pcr.loading = payload
  },
  [SET_LABORATORIES_BY_STATE] (state, payload) {
    state.pcr.laboratoriesByState = payload
  },
  [SET_STATE_SELECTED] (state, payload) {
    state.pcr.stateSelected = payload
  },
  [SET_ACTIVE] (state, payload) {
    state.pcr.active = payload
  }
}

const actions = {

  async getLaboratories ({ commit }) {
    commit(SET_LOADING, true)
    try {
      const labs = await getLaboratoryNetworks()
      commit(SET_LABORATORIES, labs)
      commit(SET_LOADING, false)
    } catch (error) {
      commit(SET_LOADING, false)
      this._vm.$sentry.logWithContext({
        ctx: {
          label: 'getLaboratories',
          error
        },
        error
      })
    }
  },

  async getStates ({ commit }) {
    commit(SET_LOADING, true)
    try {
      const states = await getStates()
      commit(SET_STATES, states)
      commit(SET_LOADING, false)
    } catch (error) {
      commit(SET_LOADING, false)
      this._vm.$sentry.logWithContext({
        ctx: {
          label: 'getStates',
          error
        },
        error
      })
    }
  },

  async getCurrentValuePCR ({ commit, state }) {
    const quantity = state.pcr.quantity || 1
    commit(SET_LOADING, true)

    try {
      const currentValue = await getQuotationPcrExam(quantity)
      commit(SET_CURRENT_VALUE, currentValue)
      commit(SET_LOADING, false)
    } catch (error) {
      commit(SET_LOADING, false)
      this._vm.$sentry.logWithContext({
        ctx: {
          label: 'getcurrentValuePCR',
          error
        },
        error
      })
    }
  },

  async getLaboratoriesByState ({ commit, state }) {
    commit(SET_LOADING, true)

    try {
      const labs = await getLaboratoriesByState(state.pcr.stateSelected.uuid)
      commit(SET_LABORATORIES_BY_STATE, labs)
      commit(SET_LOADING, false)
    } catch (error) {
      this._vm.$sentry.logWithContext({
        ctx: {
          label: 'getLaboratoriesByState',
          error
        },
        error
      })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
